import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.css'],
})
export class ColorPickerComponent implements OnInit {
  @Input() public value: any
  @Input() public name: string
  @Output() public onChange: EventEmitter<any> = new EventEmitter()

  constructor() {}

  ngOnInit() {}
}
